import { NgModule } from '@angular/core';
import { Routes, RouterModule, PreloadAllModules } from '@angular/router';

import { OnboardingComponent } from './layouts/onboarding/onboarding.component';
import { PageNotFoundComponent } from './pages/page-not-found/page-not-found.component';
import { CMeetingComponent } from './layouts/c-meeting/c-meeting.component';

import { AuthGuardService } from './services/guards/auth-guard.service';

const routes: Routes = [
  {
    path: '',
    component: OnboardingComponent,
    children: [
      {
        path: '',
        loadChildren: () => import('./layouts/onboarding/onboarding.module').then(module => module.OnboardingModule),
      },
    ],
  },
  {
    path: 'c-meeting',
    canActivate: [AuthGuardService],
    component: CMeetingComponent,
    children: [
      {
        path: '',
        loadChildren: () => import('./layouts/c-meeting/c-meeting.module').then(module => module.CMeetingModule),
      },
    ],
  },
  {
    path: '**',
    pathMatch: 'full',
    component: PageNotFoundComponent,
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
